// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  color: #253750;
  font-size: 12px;
}

.settings-page {
  padding: 2px 0 8px;
}

.page-header {
  margin-bottom: 24px;
}
.page-header h1 {
  margin: 0;
  color: #172b46;
  font-size: 22px;
  font-weight: 600;
  line-height: 30px;
  text-transform: capitalize;
}
.page-header p {
  margin: 6px 0 0;
  color: #7d8a9d;
  font-size: 12px;
  line-height: 19px;
}

.settings-card {
  margin-bottom: 16px;
  border: 1px solid #e2e9f2;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
}

.card-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 18px;
}
.card-heading h2 {
  margin: 0;
  color: #253750;
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
}
.card-heading p {
  margin: 4px 0 0;
  color: #7d8a9d;
  font-size: 12px;
  line-height: 18px;
}

.notifications-heading {
  border-bottom: 1px solid #edf1f6;
}

.button {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 35px;
  border: 1px solid #dce5ef;
  border-radius: 8px;
  padding: 7px 12px;
  background: #fff;
  color: #53647a;
  font: inherit;
  font-size: 12px;
  cursor: pointer;
}
.button .material-symbols-outlined {
  font-size: 18px;
}
.button:hover {
  border-color: color-mix(in srgb, var(--primary-color) 25%, white);
  background: color-mix(in srgb, var(--primary-color) 5%, white);
  color: var(--primary-color);
}
.button:focus-visible {
  outline: 2px solid color-mix(in srgb, var(--primary-color) 40%, white);
  outline-offset: 2px;
}

.notification-list {
  min-height: 52px;
}

.notification-row {
  padding: 14px 18px;
  color: #53647a;
  line-height: 20px;
}
.notification-row + .notification-row {
  border-top: 1px solid #edf1f6;
}

.state-message {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 88px;
  color: #8491a3;
}
.state-message .material-symbols-outlined {
  font-size: 20px;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
}

@media (max-width: 550px) {
  .page-header h1 {
    font-size: 20px;
  }
  .card-heading {
    align-items: flex-start;
    flex-direction: column;
    gap: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/settings/settings.component.scss"],"names":[],"mappings":"AAAA;EAAQ,cAAA;EAAgB,cAAA;EAAgB,eAAA;AAIxC;;AAHA;EAAiB,kBAAA;AAOjB;;AANA;EAAe,mBAAA;AAUf;AAVoC;EAAK,SAAA;EAAW,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,iBAAA;EAAmB,0BAAA;AAkB1H;AAlBwJ;EAAI,eAAA;EAAiB,cAAA;EAAgB,eAAA;EAAiB,iBAAA;AAwB9M;;AAvBA;EAAiB,mBAAA;EAAqB,yBAAA;EAA2B,mBAAA;EAAqB,gBAAA;EAAkB,gBAAA;AA+BxG;;AA9BA;EAAgB,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,SAAA;EAAW,aAAA;AAsC/F;AAtC8G;EAAK,SAAA;EAAW,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,iBAAA;AA6CjL;AA7CsM;EAAI,eAAA;EAAiB,cAAA;EAAgB,eAAA;EAAiB,iBAAA;AAmD5P;;AAlDA;EAAyB,gCAAA;AAsDzB;;AArDA;EAAU,oBAAA;EAAsB,cAAA;EAAgB,mBAAA;EAAqB,uBAAA;EAAyB,QAAA;EAAU,gBAAA;EAAkB,yBAAA;EAA2B,kBAAA;EAAoB,iBAAA;EAAmB,gBAAA;EAAkB,cAAA;EAAgB,aAAA;EAAe,eAAA;EAAiB,eAAA;AAsE9P;AAtE+Q;EAA6B,eAAA;AAyE5S;AAzE+T;EAAU,iEAAA;EAAmE,8DAAA;EAAgE,2BAAA;AA8E5c;AA9E2e;EAAkB,sEAAA;EAAwE,mBAAA;AAkFrkB;;AAjFA;EAAqB,gBAAA;AAqFrB;;AArFwC;EAAoB,kBAAA;EAAoB,cAAA;EAAgB,iBAAA;AA2FhG;AA3FmH;EAAsB,6BAAA;AA8FzI;;AA9F2K;EAAiB,aAAA;EAAe,mBAAA;EAAqB,uBAAA;EAAyB,QAAA;EAAU,gBAAA;EAAkB,cAAA;AAuGrR;AAvGqS;EAA6B,eAAA;AA0GlU;;AA1GsV;EAAmB,kBAAA;EAAoB,UAAA;EAAY,WAAA;EAAa,gBAAA;EAAkB,sBAAA;EAAwB,mBAAA;AAmHhc;;AAlHA;EAA4B;IAAkB,eAAA;EAuH5C;EAvH8D;IAAgB,uBAAA;IAAyB,sBAAA;IAAwB,SAAA;EA4H/H;AACF","sourcesContent":[":host { display: block; color: #253750; font-size: 12px; }\n.settings-page { padding: 2px 0 8px; }\n.page-header { margin-bottom: 24px; h1 { margin: 0; color: #172b46; font-size: 22px; font-weight: 600; line-height: 30px; text-transform: capitalize; } p { margin: 6px 0 0; color: #7d8a9d; font-size: 12px; line-height: 19px; } }\n.settings-card { margin-bottom: 16px; border: 1px solid #e2e9f2; border-radius: 12px; background: #fff; overflow: hidden; }\n.card-heading { display: flex; align-items: center; justify-content: space-between; gap: 20px; padding: 18px; h2 { margin: 0; color: #253750; font-size: 13px; font-weight: 600; line-height: 20px; } p { margin: 4px 0 0; color: #7d8a9d; font-size: 12px; line-height: 18px; } }\n.notifications-heading { border-bottom: 1px solid #edf1f6; }\n.button { display: inline-flex; flex: 0 0 auto; align-items: center; justify-content: center; gap: 7px; min-height: 35px; border: 1px solid #dce5ef; border-radius: 8px; padding: 7px 12px; background: #fff; color: #53647a; font: inherit; font-size: 12px; cursor: pointer; .material-symbols-outlined { font-size: 18px; } &:hover { border-color: color-mix(in srgb, var(--primary-color) 25%, white); background: color-mix(in srgb, var(--primary-color) 5%, white); color: var(--primary-color); } &:focus-visible { outline: 2px solid color-mix(in srgb, var(--primary-color) 40%, white); outline-offset: 2px; } }\n.notification-list { min-height: 52px; }.notification-row { padding: 14px 18px; color: #53647a; line-height: 20px; + .notification-row { border-top: 1px solid #edf1f6; } }.state-message { display: flex; align-items: center; justify-content: center; gap: 8px; min-height: 88px; color: #8491a3; .material-symbols-outlined { font-size: 20px; } }.visually-hidden { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; }\n@media (max-width: 550px) { .page-header h1 { font-size: 20px; }.card-heading { align-items: flex-start; flex-direction: column; gap: 14px; } }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
